import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ResourceModalHandler from 'app/components/CommonStyled/ResourceModalHandler';
import ResourceCard from 'app/components/Resources/ResourceCard';
import { LayoutGroup } from 'framer-motion';
import { resourceModalSelector } from 'store/reducers/global/global-reducer';
import { originalResourcesSelector } from 'store/reducers/resources/resources-reducer';
import { createGlobalStyle } from 'styled-components';

import {
  ResourcesStepsOneSpotlightBackgroundCardOne,
  ResourcesStepsOneSpotlightBackgroundCardTwo,
  ResourcesStepsOneSpotlightWrapper,
} from './styled';

const GlobalStyle = createGlobalStyle`
  [data-id='people-drawer-select'] {
    display: none;
  }
`;

export default function ResourcesStepsOneSpotlight() {
  const resources = useSelector(originalResourcesSelector);
  const [index, setIndex] = useState<number>(0);
  const [triggerNext, setTriggerNext] = useState<boolean>(false);
  const resourceModal = useSelector(resourceModalSelector);
  const ANIMATION_TIME = 600;

  const nextPerson = () => {
    setTriggerNext(true);
    setTimeout(() => {
      index === resources.length - 1 ? setIndex(0) : setIndex(index + 1);
      setTriggerNext(false);
    }, ANIMATION_TIME);
  };

  useEffect(() => {
    if (!resourceModal.show) {
      const timeout = setTimeout(() => {
        if (resources.length === 0) return;
        nextPerson();
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [index, resources, resourceModal]);

  if (resources.length === 0) {
    return <ResourceCard.Skeleton />;
  }

  return (
    <>
      <GlobalStyle />
      <ResourcesStepsOneSpotlightWrapper>
        <LayoutGroup>
          <ResourcesStepsOneSpotlightBackgroundCardOne triggerNext={triggerNext}>
            <ResourceCard resource={resources[index + 1 === resources.length ? 0 : index + 1]} />
          </ResourcesStepsOneSpotlightBackgroundCardOne>
          <ResourcesStepsOneSpotlightBackgroundCardTwo triggerNext={triggerNext}>
            <ResourceCard resource={resources[index]} />
          </ResourcesStepsOneSpotlightBackgroundCardTwo>
          <ResourceModalHandler />
        </LayoutGroup>
      </ResourcesStepsOneSpotlightWrapper>
    </>
  );
}
